import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTimer } from 'react-timer-hook';

import { useTimerLogic } from 'modules/Room/game-status/components/play-game-statuses/hooks/use-timer-logic';

import AnimatedTransition from 'shared/components/ui/AnimatedTransition/AnimatedTransition';
// import { CountdownTimer } from 'shared/components/ui/CountdownTimer/CountdownTimer';
import { MoveStatusRenderer } from 'shared/components/ui/MoveStatusRenderer/MoveStatusRenderer';
import { MoveStatusType } from 'shared/components/ui/MoveStatusRenderer/MoveStatusRenderer.types';
import { useRoomStore } from 'shared/store/roomStore';
import { epochToLocalUTC } from 'shared/utils/time';

export const WaitOpponentMoveStatus = () => {
  const [showTimer, setShowTimer] = useState(false);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [technicalDefeatError, setTechnicalDefeatError] = useState(false);
  const { t } = useTranslation();
  const { closerRoom } = useRoomStore();

  const { onExpire } = useTimerLogic({
    gameStatusName: 'waitOpponentMove',
    setShowTimer,
    setShowCloseButton,
    setTechnicalDefeatError,
  });

  useTimer({
    expiryTimestamp: epochToLocalUTC(closerRoom?.deadline),
    onExpire,
  });

  return (
    <>
      <AnimatedTransition show={!showTimer && !showCloseButton && !technicalDefeatError}>
        <MoveStatusRenderer
          statusIcon={MoveStatusType.WAITING_FOR_OPPONENT}
          title={t('modals.waitOpponentMove.waiting')}
        />
      </AnimatedTransition>

      <AnimatedTransition show={showTimer}>
        <MoveStatusRenderer
          statusIcon={MoveStatusType.WAITING_FOR_OPPONENT}
          title={t('modals.waitOpponentMove.waitingTimer')}
        />
      </AnimatedTransition>
      <AnimatedTransition show={showCloseButton}>
        <MoveStatusRenderer title={t('modals.waitOpponentMove.technicalDefeatExplanation')} />
      </AnimatedTransition>
      <AnimatedTransition show={technicalDefeatError}>
        <MoveStatusRenderer title={t('modals.waitOpponentMove.technicalDefeatErrorExplanation')} />
      </AnimatedTransition>
      {/* <AnimatedTransition show={showTimer && !showCloseButton}>
        <CountdownTimer
          expiryTimestamp={epochToLocalUTC(closerRoom?.deadline)}
          onComplete={onExpire}
          description={t('modals.waitOpponentMove.patient')}
        />
      </AnimatedTransition> */}
    </>
  );
};
